import React, { useState, useRef, useEffect, useMemo } from 'react';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Image1 from '../../../assest/homestay/1.jpeg'
import Image2 from '../../../assest/homestay/2.jpeg'
import Image3 from '../../../assest/homestay/3.jpeg'
import Image4 from '../../../assest/homestay/4.jpeg'
import Image5 from '../../../assest/homestay/5.jpeg'
import Image6 from '../../../assest/homestay/6.jpeg'
import Image7 from '../../../assest/homestay/7.jpeg'
import Image8 from '../../../assest/homestay/8.jpeg'
import Image9 from '../../../assest/homestay/9.jpeg'
import Image10 from '../../../assest/homestay/10.jpeg'
import Image11 from '../../../assest/homestay/11.jpeg'
import Image12 from '../../../assest/homestay/12.jpeg'
import Image13 from '../../../assest/homestay/13.jpeg'
import Image14 from '../../../assest/homestay/14.jpeg'
import Image15 from '../../../assest/homestay/15.jpeg'
import Image16 from '../../../assest/homestay/16.jpeg'
import Image17 from '../../../assest/homestay/17.jpeg'
import Image18 from '../../../assest/homestay/18.jpeg'
import Image19 from '../../../assest/homestay/19.jpeg'
import Image20 from '../../../assest/homestay/20.jpeg'
import Image21 from '../../../assest/homestay/21.jpeg'
import Image22 from '../../../assest/homestay/22.jpeg'
import Image23 from '../../../assest/homestay/23.jpeg'
import Image24 from '../../../assest/homestay/24.jpeg'
import Image25 from '../../../assest/homestay/25.jpeg'
import Image26 from '../../../assest/homestay/26.jpeg'
// import Video from '../../../assest/homestay/video1.mp4';
// import Video2 from '../../../assest/homestay/video2.mp4';
import './housedetails2gallery.scss';
import { MdOutlinePlayArrow } from "react-icons/md";

const imageList = [
	Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9,
	Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17,
	Image18, Image19, Image20, Image21, Image22, Image23, Image24, Image25, Image26
];

const HouseDetails2Gallery = () => {
	const [activeTab, setActiveTab] = useState('All');
	const [mainMedia, setMainMedia] = useState(null);
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const videoElementRef = useRef(null);


	
	const openPopup = () => {
		setIsPopupOpen(true);
	};

	const closePopup = () => {
		setIsPopupOpen(false);
	};

	const mediaItems = useMemo(() => {
		const images = imageList.map((img, index) => ({
			id: index + 1,
			type: 'image',
			src: img,
			thumbnail: img
		}));

		// const videos = [
		// 	{
		// 		id: imageList.length + 1,
		// 		type: 'video',
		// 		src: Video,
		// 		thumbnail: Image1 // fallback thumbnail
		// 	},
		// 	{
		// 		id: imageList.length + 2,
		// 		type: 'video',
		// 		src: Video2,
		// 		thumbnail: Image2
		// 	},
		// {
		// 	id: imageList.length + 3,
		// 	type: 'video',
		// 	src: Video,
		// 	thumbnail: Image3
		// }
		// ];

		// return [...images, ...videos];
		return [...images];
	}, []);

	useEffect(() => {
		if (!mainMedia && mediaItems.length > 0) {
			setMainMedia(mediaItems[0]);
		}
	}, [mainMedia, mediaItems]);

	const filteredMedia = activeTab === 'All'
		? mediaItems
		: mediaItems.filter(item => item.type === activeTab.toLowerCase());

	const mainMediaIndex = filteredMedia.findIndex(item =>
		mainMedia && item.src === mainMedia.src && item.type === mainMedia.type
	);

	useEffect(() => {
		if (videoElementRef.current) {
			if (mainMedia?.type === 'video') {
				videoElementRef.current.play().catch(error => console.error("Error attempting to play video:", error));
			} else {
				videoElementRef.current.pause();
			}
		}
	}, [mainMedia]); // Re-run when mainMedia changes

	const handleTabClick = (tabName) => {
		setActiveTab(tabName);
		const newFilteredMedia = mediaItems.filter(item => tabName === 'All' || item.type === tabName.toLowerCase());
		if (newFilteredMedia.length > 0) {
			setMainMedia(newFilteredMedia[0]); // Set to the first item of the new category
		} else {
			setMainMedia(null); // No media in this category
		}
	};

	const handleThumbnailClick = (mediaItem) => {
		setMainMedia(mediaItem);
	};

	const handleArrowClick = (direction) => {
		if (!filteredMedia.length) return;

		let newIndex = mainMediaIndex;
		if (direction === 'left') {
			newIndex = (mainMediaIndex - 1 + filteredMedia.length) % filteredMedia.length;
		} else { // direction === 'right'
			newIndex = (newIndex + 1) % filteredMedia.length;
		}
		setMainMedia(filteredMedia[newIndex]);
	};

	const photoCount = mediaItems.filter(item => item.type === 'image').length;
	// const videoCount = mediaItems.filter (item => item.type === 'video').length;

	return (
		<>
			<section className="HouseDetails2Gallery-section">
				<div className="HouseDetails2Gallery-tabs">
					<button
						className={`tab ${activeTab === 'All' ? 'active' : ''}`}
						onClick={() => handleTabClick('All')}
					>
						All
					</button>
					<button
						className={`tab ${activeTab === 'image' ? 'active' : ''}`}
						onClick={() => handleTabClick('image')}
					>
						Photos
					</button>
					{/*<button*/}
					{/*	className={`tab ${activeTab === 'video' ? 'active' : ''}`}*/}
					{/*	onClick={() => handleTabClick('video')}*/}
					{/*>*/}
					{/*	Videos*/}
					{/*</button>*/}
				</div>
				<div className="sub-HouseDetails2Gallery-section">
					<div className="HouseDetails2Gallery-main-image-container">
						{mainMedia ? (
							mainMedia.type === 'video' ? (
								<video
									key={mainMedia.src} // Crucial to force re-render/reset video element when src changes
									ref={videoElementRef}
									src={mainMedia.src}
									controls
									autoPlay // Added autoPlay to try playing when loaded
									alt={mainMedia.alt}
								>
									Your browser does not support the video tag.
								</video>
							) : (
								<img
									src={mainMedia.src}
									alt={mainMedia.alt || "Property View"}
									onClick={openPopup}
									style={{ cursor: "pointer" }}
								/>
							)
						) : (
							<p>No media available in this category.</p>
						)}

						<button
							className="nav-arrow left"
							onClick={() => handleArrowClick('left')}
							disabled={!filteredMedia.length} // Disable if no media to navigate
						>
							<FaChevronLeft className="material-symbols-outlined" />
						</button>
						<button
							className="nav-arrow right"
							onClick={() => handleArrowClick('right')}
							disabled={!filteredMedia.length} // Disable if no media to navigate
						>
							<FaChevronRight className="material-symbols-outlined" />
						</button>

						<div className="media-count">
							<span className="material-symbols-outlined">collections:</span>
							{photoCount} Photos
							{/*{photoCount} Photos + {videoCount} Videos*/}
						</div>
					</div>

					<div className="thumbnails">
						{filteredMedia.map((item, index) => (
							<div
								key={index}
								className={`thumb ${item.src === mainMedia?.src && item.type === mainMedia?.type ? 'active' : ''} ${item.type === 'video' ? 'video-thumb' : ''}`}
								onClick={() => handleThumbnailClick(item)}
							>
								{item.type === 'video' ? (
									<div className="HouseDetails2Gallery-video-thumbnail-overlay">
										<img src={item.thumbnail || "https://via.placeholder.com/180x100?text=Video"} alt={item.alt} />
										<MdOutlinePlayArrow className="material-symbols-outlined play-icon" />
									</div>
								) : (
									<img src={item.src} alt={item.alt} />
								)}
							</div>
						))}
					</div>
				</div>

				{isPopupOpen && mainMedia && (
					<div className="gallery-popup">
						<div className="popup-overlay" onClick={closePopup}>

							<div
								className="popup-content"
								onClick={(e) => e.stopPropagation()}
							>
								<button className="HouseDetails2Gallery-close-btn" onClick={closePopup}>×</button>

								<div className="popup-content-omg">
									<button
										className="nav-btn left"
										onClick={() => handleArrowClick('left')}
									>
										<FaChevronLeft />
									</button>

									{mainMedia.type === 'image' ? (
										<img src={mainMedia.src} alt="popup" />
									) : (
										<video src={mainMedia.src} controls autoPlay />
									)}

									<button
										className="nav-btn right"
										onClick={() => handleArrowClick('right')}
									>
										<FaChevronRight />
									</button>
								</div>
							</div>

						</div>
					</div>
				)}
			</section>
		</>
	);
};

export default HouseDetails2Gallery;